import styled from 'styled-components';
import colors from 'styles/colors';

/* eslint-disable import/prefer-default-export */
export const EmailBoxContainer = styled.div`
  .react-tagsinput {
    margin-bottom: 20px;
    min-height: 75px;
    box-shadow: 0 2px 4px 0 ${colors.gray85};
    background-color: ${colors.white};
    border: 1px solid ${colors.gray55};
    padding: 5px 5px 0 5px;
    font-size: 12px;
    color: ${colors.primary};

    input {
      border: 0;
      height: 21px;
    }

    .react-tagsinput-tag {
      background-color: ${colors.filterBackground};
      padding: 2px 5px;
      margin-right: 10px;
      margin-bottom: 10px;
      display: inline-flex;
      align-items: center;
      text-transform: lowercase;
    }

    .invalid-format .react-tagsinput-tag {
      background-color: ${colors.dangerLight};
    }

    .react-tagsinput-remove {
      cursor: pointer;
      font-size: 20px;
      line-height: 12px;
      margin-left: 5px;
      opacity: 0.7;

      &::before {
        content: ' ×';
      }
    }
  }
`;

export const CloseButton = styled.button`
  border: none;
  background: none;
  margin-right: 0;
  padding: 0;
`;
